import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuditProvider } from './context/AuditContext';
import { Toaster } from './components/ui/sonner';
import CheckoutPage from './pages/CheckoutPage';
import CoverPage from './pages/CoverPage';
import WelcomePage from './pages/WelcomePage';
import OperationsPage from './pages/OperationsPage';
import CustomerPage from './pages/CustomerPage';
import MarketingPage from './pages/MarketingPage';
import TeamPage from './pages/TeamPage';
import RoiPage from './pages/RoiPage';
import MatrixPage from './pages/MatrixPage';
import SummaryPage from './pages/SummaryPage';
import ActionPage from './pages/ActionPage';
import ReportPage from './pages/ReportPage';
import ResumePage from './pages/ResumePage';
import TestReportPage from './pages/TestReportPage';
import { ProtectedAuditRoute } from './components/ProtectedAuditRoute';
import ProfessionalFirmsLandingPage from './pages/ProfessionalFirmsLandingPage';
import BeforeAiTouchesClientWorkPage from './pages/BeforeAiTouchesClientWorkPage';
import './App.css';

const auditRoutes = [
  { path: 'checkout', element: <CheckoutPage />, public: true },
  { path: 'cover', element: <CoverPage /> },
  { path: 'welcome', element: <WelcomePage /> },
  { path: 'operations', element: <OperationsPage /> },
  { path: 'customer', element: <CustomerPage /> },
  { path: 'marketing', element: <MarketingPage /> },
  { path: 'team', element: <TeamPage /> },
  { path: 'roi', element: <RoiPage /> },
  { path: 'matrix', element: <MatrixPage /> },
  { path: 'summary', element: <SummaryPage /> },
  { path: 'action', element: <ActionPage /> },
  { path: 'report', element: <ReportPage /> },
  { path: 'test-report', element: <TestReportPage />, public: true },
  { path: 'resume', element: <ResumePage />, public: true },
];

function renderAuditRoutes(prefix = '') {
  return auditRoutes.map(({ path, element, public: isPublic }) => (
    <Route
      key={`${prefix}/${path}`}
      path={`${prefix}/${path}`}
      element={isPublic ? element : <ProtectedAuditRoute>{element}</ProtectedAuditRoute>}
    />
  ));
}

function App() {
  return (
    <AuditProvider>
      <BrowserRouter>
        <div className="App">
          <Routes>
            <Route path="/" element={<Navigate to="/audit/checkout" replace />} />
            <Route path="/professional-firms-ai-audit" element={<ProfessionalFirmsLandingPage />} />
            <Route path="/resources/before-ai-touches-client-work" element={<BeforeAiTouchesClientWorkPage />} />
            <Route path="/audit" element={<Navigate to="/audit/checkout" replace />} />
            {renderAuditRoutes('')}
            {renderAuditRoutes('/audit')}
          </Routes>
          <Toaster position="top-right" />
        </div>
      </BrowserRouter>
    </AuditProvider>
  );
}

export default App;